'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_shopping$package$StoreCartItemId$() {
  this.a9S = 0;
  this.a9T = 0;
  $n_Lmealorama_shopping$package$StoreCartItemId$ = this;
  $m_Lmealorama_shopping$package$StoreCartItemId$();
  this.a9S = 0;
  this.a9T = 0;
}
export { $c_Lmealorama_shopping$package$StoreCartItemId$ as $c_Lmealorama_shopping$package$StoreCartItemId$ };
$p = $c_Lmealorama_shopping$package$StoreCartItemId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_shopping$package$StoreCartItemId$;
/** @constructor */
function $h_Lmealorama_shopping$package$StoreCartItemId$() {
}
export { $h_Lmealorama_shopping$package$StoreCartItemId$ as $h_Lmealorama_shopping$package$StoreCartItemId$ };
$h_Lmealorama_shopping$package$StoreCartItemId$.prototype = $p;
var $d_Lmealorama_shopping$package$StoreCartItemId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_shopping$package$StoreCartItemId$, "mealorama.shopping$package$StoreCartItemId$", ({
  LV: 1
}));
export { $d_Lmealorama_shopping$package$StoreCartItemId$ as $d_Lmealorama_shopping$package$StoreCartItemId$ };
var $n_Lmealorama_shopping$package$StoreCartItemId$;
function $m_Lmealorama_shopping$package$StoreCartItemId$() {
  if ((!$n_Lmealorama_shopping$package$StoreCartItemId$)) {
    $n_Lmealorama_shopping$package$StoreCartItemId$ = new $c_Lmealorama_shopping$package$StoreCartItemId$();
  }
  return $n_Lmealorama_shopping$package$StoreCartItemId$;
}
export { $m_Lmealorama_shopping$package$StoreCartItemId$ as $m_Lmealorama_shopping$package$StoreCartItemId$ };
//# sourceMappingURL=mealorama.shopping$package$-Store-Cart-Item-Id$.js.map
